/* eslint-disable react/prop-types */
import React, { Component } from "react";
import {
  Segment, Form, Input, Button, Divider, Dimmer,
  Loader, Container, Popup, Icon,
} from "semantic-ui-react";
import { withRouter } from "react-router-dom";

import Constants from "../utilities/Constants";
import Strings from "../utilities/StringSelector";
import Utils from "../utilities/Utils";
const UtilsInstance = new Utils();

export class ChannelsTime extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      // Ethernet info
      channel1: "",
      channel2: "",
      channel3: "",
      channel4: "",
      channel5: "",
      // Dimmers
      isChannelsTimeConfigDimmerActive: false,
    };
  }

  retrieveData = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "timePerChannels", { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({
        channel1: data.channel1,
        channel2: data.channel2,
        channel3: data.channel3,
        channel4: data.channel4,
        channel5: data.channel5,
      }));
  }

  sendChannelTimeValues = () => {
    this.setState({ isChannelsTimeConfigDimmerActive: true }, () => {
      // Verificar primeiro se todos os valores são válidos
      const isNaturalNumber = /^\d+$/;

      const isChannel1Valid = isNaturalNumber.test(this.state.channel1);
      const isChannel2Valid = isNaturalNumber.test(this.state.channel2);
      const isChannel3Valid = isNaturalNumber.test(this.state.channel3);
      const isChannel4Valid = isNaturalNumber.test(this.state.channel4);
      const isChannel5Valid = isNaturalNumber.test(this.state.channel5);

      if (!isChannel1Valid || !isChannel2Valid || !isChannel3Valid || !isChannel4Valid || !isChannel5Valid) {
        let errorString = "";

        if (!isChannel1Valid) {
          errorString += `${Strings.ERROR_MSG_1} ${Strings.CHANNEL_1} ${Strings.ERROR_MSG_2}\n`;
        }

        if (!isChannel2Valid) {
          errorString += `${Strings.ERROR_MSG_1} ${Strings.CHANNEL_2} ${Strings.ERROR_MSG_2}\n`;
        }

        if (!isChannel3Valid) {
          errorString += `${Strings.ERROR_MSG_1} ${Strings.CHANNEL_3} ${Strings.ERROR_MSG_2}\n`;
        }

        if (!isChannel4Valid) {
          errorString += `${Strings.ERROR_MSG_1} ${Strings.CHANNEL_4} ${Strings.ERROR_MSG_2}\n`;
        }

        if (!isChannel5Valid) {
          errorString += `${Strings.ERROR_MSG_1} ${Strings.CHANNEL_5} ${Strings.ERROR_MSG_2}\n`;
        }

        errorString += Strings.CHANNELS_TIME_POPUP_2;

        alert(errorString);
        this.setState({ isChannelsTimeConfigDimmerActive: false });
      }
      else {
        let data = JSON.stringify({
          "channel1": parseInt(this.state.channel1),
          "channel2": parseInt(this.state.channel2),
          "channel3": parseInt(this.state.channel3),
          "channel4": parseInt(this.state.channel4),
          "channel5": parseInt(this.state.channel5)
        });

        fetch(Constants.REQUEST_IP_ADDRESS + "timePerChannels_POST", {
          method: "POST",
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          body: data,
          mode: "cors"
        })
          .then(UtilsInstance.checkStatus)
          .then(() => {
            alert(Strings.CONFIGURE_CHANNELS_TIME_SUCCESS);
            this.setState({ isChannelsTimeConfigDimmerActive: false }, () => {
              this.retrieveData();
            });
          })
          .catch((error) => {
            alert(Strings.CONFIGURE_CHANNELS_TIME_ERROR + Strings.ERROR_REASON + error);
            this.setState({ isChannelsTimeConfigDimmerActive: false });
          });
      }
    });
  }

  // ----------------- Event Handlers -----------------
  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  // Verifies if the user has the credentials to be logged in
  // If he does he is re-directed to the configuration page
  // If he doesn't he is re-directed to the login page
  isUserLoggedIn = () => {
    if (sessionStorage.auth !== Constants.AUTH_STR) {
      this.props.history.push({ pathname: "/login" });
    }
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.isUserLoggedIn();
    this.retrieveData();
  }

  render() {
    const isChannelsTimeConfigDimmerActive = this.state.isChannelsTimeConfigDimmerActive;

    return (
      <Container text>

        <Segment>
          <Divider horizontal>
            {Strings.CHANNELS_TIME}
            <Popup position='bottom center' hoverable pinned wide="very"
              trigger={<Icon name="question circle" size="big" color="teal" style={questionIconStyle} />}>
              <Popup.Content>
                <p>{Strings.CHANNELS_TIME_POPUP_1}</p>
                <p>{Strings.CHANNELS_TIME_POPUP_2}</p>
                <ul>
                  <li>{Strings.CHANNELS_TIME_POPUP_3} <b>{Constants.MIN_INTERVAL} {Strings.MEASURE_UNIT_1}</b>.</li>
                  <li>{Strings.CHANNELS_TIME_POPUP_4} <b>{Constants.MAX_INTERVAL} {Strings.MEASURE_UNIT_2}</b> {Strings.CHANNELS_TIME_POPUP_5}</li>
                </ul>
              </Popup.Content>
            </Popup>
          </Divider>
          <Form style={formStyle} onSubmit={this.sendChannelTimeValues}>

            <Form.Field inline>
              <label>{Strings.CHANNEL_1}</label>
              <Input
                type="number"
                min={Constants.MIN_INTERVAL}
                max={Constants.MAX_INTERVAL}
                placeholder={Strings.CHANNEL_TIME_PLACEHOLDER}
                label={{ basic: true, content: Strings.MEASURE_UNIT }}
                labelPosition="right"
                name="channel1"
                value={this.state.channel1}
                onChange={this.handleChange} />
            </Form.Field>

            <Form.Field inline>
              <label>{Strings.CHANNEL_2}</label>
              <Input
                type="number"
                min={Constants.MIN_INTERVAL}
                max={Constants.MAX_INTERVAL}
                placeholder={Strings.CHANNEL_TIME_PLACEHOLDER}
                label={{ basic: true, content: Strings.MEASURE_UNIT }}
                labelPosition="right"
                name="channel2"
                value={this.state.channel2}
                onChange={this.handleChange} />
            </Form.Field>

            <Form.Field inline>
              <label>{Strings.CHANNEL_3}</label>
              <Input
                type="number"
                min={Constants.MIN_INTERVAL}
                max={Constants.MAX_INTERVAL}
                placeholder={Strings.CHANNEL_TIME_PLACEHOLDER}
                label={{ basic: true, content: Strings.MEASURE_UNIT }}
                labelPosition="right"
                name="channel3"
                value={this.state.channel3}
                onChange={this.handleChange} />
            </Form.Field>

            <Form.Field inline>
              <label>{Strings.CHANNEL_4}</label>
              <Input
                type="number"
                min={Constants.MIN_INTERVAL}
                max={Constants.MAX_INTERVAL}
                placeholder={Strings.CHANNEL_TIME_PLACEHOLDER}
                label={{ basic: true, content: Strings.MEASURE_UNIT }}
                labelPosition="right"
                name="channel4"
                value={this.state.channel4}
                onChange={this.handleChange} />
            </Form.Field>

            <Form.Field inline>
              <label>{Strings.CHANNEL_5}</label>
              <Input
                type="number"
                min={Constants.MIN_INTERVAL}
                max={Constants.MAX_INTERVAL}
                placeholder={Strings.CHANNEL_TIME_PLACEHOLDER}
                label={{ basic: true, content: Strings.MEASURE_UNIT }}
                labelPosition="right"
                name="channel5"
                value={this.state.channel5}
                onChange={this.handleChange} />
            </Form.Field>

            <Button color="teal" type="submit" >{Strings.SETUP}</Button>
          </Form>
          <Dimmer active={isChannelsTimeConfigDimmerActive} >
            <Loader>{Strings.SEND_CONFIG_WAITING}</Loader>
          </Dimmer>
        </Segment>
      </Container>

    );
  }
}

const formStyle = {
  marginTop: "24px",
  textAlign: "center",
  width: "100%"
};

const questionIconStyle = {
  marginLeft: "4px"
};

export default withRouter(ChannelsTime);
